export default __webpack_public_path__ + "static/media/stripe_wordmark.eab9a3ac.svg";